import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Join class names, letting later Tailwind utilities win over earlier ones.
 * The only class-merging helper in the design system — don't hand-roll a second.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
